import { render, staticRenderFns } from "./SvgPathIcon.vue?vue&type=template&id=7d7fe61e&scoped=true"
import script from "./SvgPathIcon.vue?vue&type=script&lang=js"
export * from "./SvgPathIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgPathIcon.vue?vue&type=style&index=0&id=7d7fe61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7fe61e",
  null
  
)

export default component.exports